<template>
  <div>
    <div class="reports-stage">
      <div class="row">
        <div class="stage-title">Raporty</div>
        <hr />
      </div>
      <ReportsListView />
    </div>
  </div>
</template>

<script>
import ReportsListView from "@/views/ReportsManager/ReportsListView.vue";

export default {
  name: "ReportsStage",
  components: {
    ReportsListView,
  },
};
</script>

<style scoped>
.reports-stage {
  margin-left: 16px;
  margin-right: 16px;
}
</style>

